module.exports = __webpack_public_path__ + "static/media/logo.dc23ae16.png";